import * as React from "react";
import { Phone, CalendarCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ScheduleReadyCTA() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Handy Heroes",
    "telephone": "(470) 847-9076",
    "url": "https://handyheroesatl.com/",
    "areaServed": ["Atlanta", "Alpharetta", "Marietta", "Gwinnett", "Cobb"],
    "makesOffer": [{
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "HVAC Services"
      }
    }]
  };
  return <section id="schedulereadycta" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-4xl overflow-hidden rounded-2xl border border-border bg-card p-8 text-center shadow-lg md:p-12 lg:p-16">
          <h2 className="mb-4 font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Ready to Schedule?
          </h2>
          <p className="mx-auto mb-8 max-w-2xl text-lg text-muted-foreground">
            Connect with local independent HVAC pros in the Atlanta area. Your pro gives a quote before work starts.
          </p>
          
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="#bookingrequest">
                <CalendarCheck className="mr-2 size-5" />
                Request a Quote
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <a href="tel:+14708479076" className="inline-flex items-center">
                <Phone className="mr-2 size-5" />
                Call (470) 847-9076
              </a>
            </Button>
          </div>
        </div>
      </div>

      {}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />
    </section>;
}